// This route is deprecated, keeping file to avoid breaking bookmarks before <Redirect to="/dashboard" /> is evaluated.
export default {
  key: "activity-center",
  path: "/activity-center/:tab?",
  basePath: "activity-center",
};
